<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`${activeId ? '编辑' : '新增'} ${archivesTypeFilter(archivesType)}`"
    width="600px"
    height="400px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="上传文件" prop="fileList" ref="fileFormItem" required>
            <UploadButton
              v-model="editForm.fileList"
              :limit="1"
              :fileType="['doc', 'docx', 'pdf', 'PDF', 'xls', 'xlsx', 'txt', 'ppt', 'pptx', 'PPT', 'PPTX', 'zip', 'rar']"
              :paramsData="{ type: 'upt_archives' }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import UploadButton from '@/components/UploadArea/UploadButton';

import { getAppFile, editAppFile } from '@/api/archives';

export default {
  components: { UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    },
    archivesType: {
      type: String,
      default: 'file_type_zizhi'
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {
        id: null,
        fileNo: '',
        versionCode: '',
        remark: '',
        fileList: []
      },
      rules: {
        fileList: [{ required: true, message: '请上传关联文件', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  filters: {},
  watch: {
    visible(val) {
      if (val) {
        if (this.activeId) {
          this.getAppFile();
        }
      }
    },
    'editForm.fileList'(val) {
      if (val && val.length > 0) {
        this.$nextTick(() => {
          this.$refs.fileFormItem.clearValidate();
        });
      }
    }
  },
  methods: {
    async getAppFile() {
      const { data } = await getAppFile({ id: this.activeId });
      this.editForm.id = data.id;
      this.editForm.fileNo = data.fileNo || '';
      this.editForm.versionCode = data.versionCode || '';
      this.editForm.remark = data.remark || '';
      this.editForm.fileList = [{ fileName: data.fileName, filePath: data.filePath }];
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const fileName = this.editForm.fileList?.[0]?.fileName ?? null;
          const filePath = this.editForm.fileList?.[0]?.filePath ?? null;
          const params = {
            id: this.editForm.id,
            type: this.archivesType,
            fileName,
            filePath,
            fileNo: this.editForm.fileNo,
            versionCode: this.editForm.versionCode,
            remark: this.editForm.remark
          };

          try {
            await editAppFile(params);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    archivesTypeFilter(val) {
      switch (val) {
        case 'file_type_zizhi':
          return '资质文件';
        case 'file_type_biaozhun':
          return '各类标准文件';
        case 'file_type_zhidao':
          return '作业指导书';
        case 'file_type_guifan':
          return '操作规程';
        case 'file_type_law':
          return '法律法规';
        case 'file_type_guanlitixi':
          return '管理体系文件';
        case 'file_type_fawen':
          return '公司发文';
        case 'file_type_peixun':
          return '培训课件';
        case 'file_type_shoukongjilu':
          return '受控记录-综合管理部';
        case 'file_type_shoukongjilu_SKKF':
          return '受控记录-市场开发部';
        case 'file_type_shoukongjilu_JSYF':
          return '受控记录-技术研发部';
        case 'file_type_shoukongjilu_JCZX':
          return '受控记录-检测试验中心';
        case 'file_type_shoukongjilu_GCXJ':
          return '受控记录-工程质量检测中心';
        case 'file_type_shoukongjilulist':
          return '受控记录清单';
        case 'file_type_model_ori':
          return '检测试验中心原始记录模版';
        case 'file_type_model_report':
          return '检测试验中心报告模版';
        case 'file_type_model_ori_porject':
          return '工程质量检测中心原始记录模版';
        case 'file_type_model_report_porject':
          return '工程质量检测中心报告模版';
        default:
          return '档案';
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
